(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 7627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(8847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ForgotPass; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(6312);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./src/context/index.tsx + 7 modules
var context = __webpack_require__(598);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
// EXTERNAL MODULE: ./src/validation/index.ts + 6 modules
var validation = __webpack_require__(2620);
;// CONCATENATED MODULE: ./src/components/auth/forgot-password.tsx





/* eslint-disable complexity */ /* eslint-disable jsx-a11y/label-has-associated-control */ 





var ForgotPassword = function() {
    var ref;
    var abortController = (0,context/* useCart */.jD)().abortController;
    var ref1 = (0,react.useState)(""), authErrorMessage = ref1[0], setAuthErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(""), successMessage = ref2[0], setSuccessMessage = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(validation/* forgotPasswordSchema */.ek),
        mode: "all"
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, _formState = ref3.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, touchedFields = _formState.touchedFields, dirtyFields = _formState.dirtyFields, reset = ref3.reset;
    var containsErrorsEmail = Object.keys(errors).includes("email");
    var emailValidation = !containsErrorsEmail && dirtyFields.email ? "primary-input-isValid" : touchedFields.email && "primary-input-isInvalid";
    function onSubmitForm(values) {
        return _onSubmitForm.apply(this, arguments);
    }
    function _onSubmitForm() {
        _onSubmitForm = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var responseOptions, response, data, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (authErrorMessage) {
                            setAuthErrorMessage("");
                        }
                        responseOptions = {
                            method: "POST",
                            body: JSON.stringify({
                                username: values.email
                            }),
                            signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        _ctx.next = 5;
                        return fetch("".concat("https://preview.tuckertub.com.au", "/api/auth/forgot-password"), responseOptions);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        data = _ctx.sent;
                        console.log("ResetForgotPasswordData", data);
                        if (!data.data.sendPasswordResetEmail) {
                            _ctx.next = 14;
                            break;
                        }
                        {
                            // toast.success('Registered!')
                            reset();
                            setSuccessMessage("Success! Check your email for a link to reset your password.");
                        }
                        _ctx.next = 16;
                        break;
                    case 14:
                        ;
                        throw new Error((ref = data.errors) === null || ref === void 0 ? void 0 : ref[0].message);
                    case 16:
                        _ctx.next = 26;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("ResetForgotPasswordError", _ctx.t0);
                        setSuccessMessage("");
                        if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                            _ctx.next = 25;
                            break;
                        }
                        if (!_ctx.t0.message.includes("There is no user registered with that email address")) {
                            _ctx.next = 25;
                            break;
                        }
                        return _ctx.abrupt("return", setAuthErrorMessage(_ctx.t0.message));
                    case 25:
                        setAuthErrorMessage("Something went wrong");
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return _onSubmitForm.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "max-w-[440px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                className: "text-colorFourteen",
                children: "Forgot Password"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit(onSubmitForm),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 gap-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "email",
                                    style: {
                                        boxShadow: "none",
                                        borderColor: "transparent"
                                    },
                                    className: "primary-input ".concat(emailValidation),
                                    placeholder: "Email address",
                                    autoComplete: "email",
                                    "aria-label": "Email address"
                                }, register("email"))),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "p-0 text-colorThirteen",
                                    children: containsErrorsEmail && ((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                                buttonType: "submit",
                                buttonVariant: "primary",
                                children: isSubmitting ? "Processing..." : "Forgot Password"
                            })
                        }),
                        authErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "p-0 text-colorThirteen",
                                children: authErrorMessage
                            })
                        }),
                        successMessage && !authErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "p-0 text-colorTen",
                                children: successMessage
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
;// CONCATENATED MODULE: ./src/pages/forgot-password.tsx





var __N_SSP = true;
function ForgotPass() {
    var ref = (0,context/* useAuth */.aC)(), user = ref.user, isAuthenticated = ref.isAuthenticated;
    console.log("user", user);
    console.log("isAuthenticated", isAuthenticated);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Forgot Password | Tucker Tub",
                description: "Forgot Password Description",
                openGraph: {
                    title: "Forgot Password  | Tucker Tub",
                    description: "Forgot Password Description",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-inherit bg-colorFifteen",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "container grid min-h-inherit grid-cols-1 space-x-0 py-20 sm:grid-cols-2 sm:space-x-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword, {})
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 6079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ checkoutFormDeliverySchema; }
/* harmony export */ });
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var checkoutFormDeliverySchema = zod__WEBPACK_IMPORTED_MODULE_0__.z.object({
    shippingMethod: zod__WEBPACK_IMPORTED_MODULE_0__.z.boolean().refine(function(val) {
        return val;
    }, "Please select a shipping method")
});


/***/ }),

/***/ 1437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ emailViewExistingCustomerSchema; }
/* harmony export */ });
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var emailViewExistingCustomerSchema = zod__WEBPACK_IMPORTED_MODULE_0__.z.object({
    email: zod__WEBPACK_IMPORTED_MODULE_0__.z.string().email({
        message: "Please enter a valid email address"
    }).min(1, "Please enter an email address"),
    password: zod__WEBPACK_IMPORTED_MODULE_0__.z.string().min(1, "Please enter a password")
});


/***/ }),

/***/ 2620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ud": function() { return /* reexport */ checkoutFormShippingSchema; },
  "SL": function() { return /* reexport */ emailViewSchema; },
  "ek": function() { return /* reexport */ forgotPasswordSchema; },
  "dm": function() { return /* reexport */ loginSchema; },
  "gY": function() { return /* reexport */ registerSchema; },
  "S4": function() { return /* reexport */ resetPasswordSchema; }
});

// UNUSED EXPORTS: checkoutFormDeliverySchema, emailViewExistingCustomerSchema

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/validation/checkout-view-email-view.schema.ts

var emailViewSchema = lib.z.object({
    email: lib.z.string().email({
        message: "Please enter a valid email address"
    }).min(1, "Please enter an email address"),
    isSignUpEmail: lib.z.boolean().optional()
});

;// CONCATENATED MODULE: ./src/validation/checkout-form-shipping.schema.ts

var checkoutFormShippingSchema = lib.z.object({
    firstName: lib.z.string().min(1, "Please enter a first name"),
    lastName: lib.z.string().min(1, "Please enter a last name"),
    phone: lib.z.string().regex(/^[0-9]{8,10}$/, "Please enter a valid phone number").optional().or(lib.z.literal("")),
    address1: lib.z.string().min(1, "Please enter an address"),
    address2: lib.z.string().optional(),
    suburb: lib.z.string().optional(),
    state: lib.z.string().min(1, "Please enter a state"),
    postcode: lib.z.string().min(4, "Please enter a postcode").max(4, "Please enter a postcode"),
    country: lib.z.string().optional()
});

// EXTERNAL MODULE: ./src/validation/checkout-view-email-view-existing-customer.schema.ts.ts
var checkout_view_email_view_existing_customer_schema_ts = __webpack_require__(1437);
// EXTERNAL MODULE: ./src/validation/checkout-form-delivery.schema.ts
var checkout_form_delivery_schema = __webpack_require__(6079);
;// CONCATENATED MODULE: ./src/validation/register.schema.ts

var registerSchema = lib.z.object({
    firstName: lib.z.string().min(1, "Please enter a first name"),
    lastName: lib.z.string().min(1, "Please enter a last name"),
    email: lib.z.string().email({
        message: "Please enter a valid email address"
    }).min(1, "Please enter an email address"),
    password: lib.z.string().min(6, "Please enter a password of at least 6 characters"),
    isSignUpEmail: lib.z.boolean().optional(),
    isAgreedToTerms: lib.z.boolean().refine(function(val) {
        return val;
    }, "Please agree to the Terms of Service")
});

;// CONCATENATED MODULE: ./src/validation/login.schema.ts

var loginSchema = lib.z.object({
    email: lib.z.string().email({
        message: "Please enter a valid email address"
    }).min(1, "Please enter an email address"),
    password: lib.z.string().min(1, "Please enter a password")
});

;// CONCATENATED MODULE: ./src/validation/forgot-password.schema.ts

var forgotPasswordSchema = lib.z.object({
    email: lib.z.string().email({
        message: "Please enter a valid email address"
    }).min(1, "Please enter an email address")
});

;// CONCATENATED MODULE: ./src/validation/reset-password.schema.ts

var resetPasswordSchema = lib.z.object({
    newPassword: lib.z.string().min(1, "Please enter a new password")
});

;// CONCATENATED MODULE: ./src/validation/index.ts










/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,3760,5812,8969,9774,2888,179], function() { return __webpack_exec__(7627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);